import React, { useEffect, useState } from "react";
import "./styles.scss";

import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";

// import required modules
import { Navigation } from "swiper/modules";
const TitleSlider = (props) => {
  const { bundle_name, allSelectedVariant } = props;
  const [priceValue, setPriceValue] = useState({
    price: null,
    strick_price: null,
  });
  let regular_price = null;
  let display_price = null;

  useEffect(() => {
    if (allSelectedVariant?.length) {
      let regPrice = null;
      let price = null;

      allSelectedVariant.map((item) => {
        if (item.display_regular_price) {
          regPrice = regPrice + item.display_regular_price;
        }
        if (item.display_regular_price) {
          price = price + item.display_price;
        }
      });
      display_price = price;
      regular_price = regPrice;
      setPriceValue({
        price: display_price,
        strick_price: regular_price,
      });
    }
  }, [allSelectedVariant]);

  // Format as currency with CAD currency symbol
  const formattedPrice = (price) => {
    return new Intl.NumberFormat("en-CA", {
      style: "currency",
      currency: "CAD",
    }).format(price);
  };

  return (
    <Swiper navigation={true} modules={[Navigation]} className="title-swiper">
      <SwiperSlide>
        <h3>{bundle_name}</h3>
        {priceValue?.price || priceValue?.strick_price ? (
          <p className="currency">
            <span className="offer-price">
              {formattedPrice(priceValue?.price)} CAD
            </span>
            {priceValue?.price !== priceValue?.strick_price ? (
              <span className="cross-price">
                {formattedPrice(priceValue?.strick_price)} CAD
              </span>
            ) : (
              ""
            )}
          </p>
        ) : null}
      </SwiperSlide>
    </Swiper>
  );
};

export default TitleSlider;
